import { render, staticRenderFns } from "./AbstractOfObservation.vue?vue&type=template&id=521c3f6b&scoped=true&"
import script from "./AbstractOfObservation.vue?vue&type=script&lang=js&"
export * from "./AbstractOfObservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c3f6b",
  null
  
)

export default component.exports